import { atom } from 'jotai';
import LoanInterface from "@/types_and_interfaces/loan_interface";
import { atomWithStorage } from 'jotai/utils'
import {SyncStorage} from "jotai/vanilla/utils/atomWithStorage";
import CommonClass from "@/utils/common.ts";
import UserInterface from "@/types_and_interfaces/user_interface.ts";
import NotificationInterface from "@/types_and_interfaces/notification_interface.tsx";
import PaginatedNotificationsInterface from "@/types_and_interfaces/paginated_notifications_interface.ts";


const customLocalStorage: SyncStorage<string> = {
    getItem(key: string) {
        const value = localStorage.getItem(key);
        return value !== null ? value : '';
    },
    setItem(key: string, value: string | null) {
        if (value === null || value === undefined) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }
    },
    removeItem(key: string) {
        localStorage.removeItem(key);
    },
};

export const loan_sidebar_data = atomWithStorage<any>(
    CommonClass.local_storage_fields.loan_sidebar_data,
    '',
    customLocalStorage
);

export const open_gen_dashboard_menu = atom<boolean>(false);
export const open_notifications_sidebar = atom<boolean>(false);
export const user_credits = atom<Array<LoanInterface> | undefined>(undefined)
export const apply_credit_monthly_payment  = atom<number>(0)
export const profile  = atom<UserInterface | undefined>(undefined)
// export const device_uid = atomWithStorage<string>(CommonClass.local_storage_fields.device_uid, "", customLocalStorage)
export const login_data = atomWithStorage<string>(CommonClass.local_storage_fields.login_data, "", customLocalStorage)
export const have_logged_data = atomWithStorage<string>(CommonClass.local_storage_fields.have_logged_data, "", customLocalStorage)
export const all_notifications = atom<Array<NotificationInterface> | undefined>(undefined)
// export const paginated_notifications = atom<PaginatedNotificationsInterface | {} >({})
export const paginated_notifications = atom<PaginatedNotificationsInterface | undefined>(undefined)
export const stored_notifications = atom<PaginatedNotificationsInterface | undefined>(undefined)
export const notif_current_page  = atom<number>(1)
export const unread_notif  = atom<number | undefined>(undefined)
